import { render } from "./CreditOwnerComponent.vue?vue&type=template&id=17f44628&scoped=true"
import script from "./CreditOwnerComponent.vue?vue&type=script&lang=js"
export * from "./CreditOwnerComponent.vue?vue&type=script&lang=js"

import "./CreditOwnerComponent.vue?vue&type=style&index=0&id=17f44628&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17f44628"]])

export default __exports__